import { render, staticRenderFns } from "./CareGiver2.vue?vue&type=template&id=14201128&scoped=true&"
import script from "./CareGiver2.vue?vue&type=script&lang=ts&"
export * from "./CareGiver2.vue?vue&type=script&lang=ts&"
import style0 from "./CareGiver2.vue?vue&type=style&index=0&id=14201128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14201128",
  null
  
)

export default component.exports